import { generateId } from '../../../utils/generate-id.util';

// A representative just selected: its roles and types are inherited from its membership until
// set.
export const newRepresentativeOf = (personId: string, index: number) => ({
  _id: generateId(),
  index,
  personId,
  contextualRoleIds: undefined,
  typeIds: undefined,
});
